import { CardContent, Divider } from "@mui/material";
import { AboutIcon, Card, Grid, Spacer, Typography } from "../style";
import { Email, Home, Person, Phone, PhoneAndroid } from "@mui/icons-material";

const Legale = ({ legale }) => {
  if (!legale || legale == {}) {
    return;
  }
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Legale
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Person />
            </AboutIcon>
          </Grid>
          <Grid item>
            {legale?.cognome} {legale?.nome}{" "}
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Home />
            </AboutIcon>
          </Grid>
          <Grid item>
            {legale.slResIndirizzoVia?.value &&
              legale.slResIndirizzo &&
              legale.slResCivico &&
              legale.slResProvincia &&
              `${legale.slResIndirizzoVia?.value} 

                ${legale.slResIndirizzo}, ${legale.slResCivico},{" "}
                ${legale.slResProvincia}`}
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Email />
            </AboutIcon>
          </Grid>
          <Grid item>{legale?.email}</Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <PhoneAndroid />
            </AboutIcon>
          </Grid>
          <Grid item>{legale?.cellulare}</Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Phone />
            </AboutIcon>
          </Grid>
          <Grid item>{legale?.telefono}</Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  );
};

export default Legale;
